import { render, staticRenderFns } from "./blocked-user-list.html?vue&type=template&id=33413024&scoped=true&external"
import script from "./blocked-user-list.js?vue&type=script&lang=js&external"
export * from "./blocked-user-list.js?vue&type=script&lang=js&external"
import style0 from "./blocked-user-list.scss?vue&type=style&index=0&id=33413024&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33413024",
  null
  
)

export default component.exports